import React from 'react';
import { useRevealAnimation } from '@/hooks/useRevealAnimation';

type Heading3Props = {
  children?: React.ReactNode;
  text?: string;
  id?: string;
  description?: string;
};

export const Heading3: React.FC<Heading3Props> = ({
  children,
  text,
  id,
  description,
}) => {
  const { ref, isVisible } = useRevealAnimation();

  return (
    <div className="mt-28 mb-8">
      <h3
        ref={ref}
        id={id}
        className={`text-2xl mb-2 dark:text-white scroll-mt-24 transform transition-all duration-700 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0'
        }`}
      >
        {text ?? children}
      </h3>

      {description && (
        <p
          className={`text-base text-zinc-700 dark:text-zinc-300 mt-2 mb-6 transform transition-all duration-700 delay-100 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
          }`}
        >
          {description}
        </p>
      )}

      <div
        className={`w-full h-px bg-zinc-200 dark:bg-zinc-800 transform transition-all duration-700 delay-200 ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
      />
    </div>
  );
};
